import { API_URL } from '../../../app-config/constants';
import { SurveyTemplate } from '../../../types/SurveyTemplate';
import { get } from '../request';

const ENTRY = `${API_URL}/survey-templates`;

getAll.operation = 'READ';
export function getAll(): Promise<SurveyTemplate[]> {
    return get(ENTRY);
}
